var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question_1_",
    "data-name": "question (1)",
    transform: "translate(-14.5 -14.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M53.237,369.452a1.016,1.016,0,0,1-1,.824H48.177l-2.031,1.632v-1.632a1.016,1.016,0,0,1-1.015-1.016v-.82a1.616,1.616,0,0,0,.812.217h6.5Z",
    transform: "translate(-29.317 -343.907)",
    fill: "none",
    stroke: "#347fb7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M28,16.625v6.5a1.624,1.624,0,0,1-1.625,1.625V28l-3.25-3.25h-6.5A1.624,1.624,0,0,1,15,23.125v-6.5A1.625,1.625,0,0,1,16.625,15h9.75A1.625,1.625,0,0,1,28,16.625Z",
    fill: "none",
    stroke: "#347fb7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(20.281 17.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M210.812,91.938v-.406a1.219,1.219,0,0,1,1.219-1.219h0a1.219,1.219,0,0,1,1.219,1.219h0a1.219,1.219,0,0,1-.357.862l-.489.489a1.219,1.219,0,0,0-.357.862v.631",
    transform: "translate(-210.812 -90.313)",
    fill: "none",
    stroke: "#347fb7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(0.814 5.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M241.392,287a.4.4,0,1,0-.4-.4.409.409,0,0,0,.4.4Z",
    transform: "translate(-240.987 -286.188)",
    fill: "#347fb7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.34a1a68b05a0366e957549f243a3db87.svg";
export { ForwardRef as ReactComponent };